import { useSelector } from 'react-redux';
import core, { View } from '@gin-betting/core';

import { State } from 'types';
import { selectRouteByTournament } from 'selectors';
import { getLinkToTopTournamentBySlug } from '../../utils';

const {
    entities: {
        selectors: { selectTournamentByIdFromProps },
    },
} = core;

interface Input {
    tournamentId: string;
}

interface Tournament extends View.Tournament {
    linkToTournament: string;
}

type Output = Tournament | null;

const selectProps = (state: State, { tournamentId }: Input) => {
    const tournament = selectTournamentByIdFromProps(state, { tournamentId });
    const route = selectRouteByTournament(state, { tournamentId });

    return {
        tournament,
        route,
    };
};

const useTopTournament = ({ tournamentId }: Input): Output => {
    const { tournament, route } = useSelector((state: State) =>
        selectProps(state, { tournamentId })
    );

    if (!tournament) return null;

    const { slug } = tournament;

    const linkToTournament = getLinkToTopTournamentBySlug(slug, route);

    return {
        ...tournament,
        linkToTournament,
    };
};

export default useTopTournament;
